import React, { useState, useEffect } from "react";
import { Paginator } from "../../../../layout/Paginator/Paginator";
import { Search } from "../../../../layout/Table/Search";
import { TableComponent } from "../table/TableComponent";
import { CreateUser } from "../table/buttons/CreateUser";
import { ACL } from '../../../../../config/constants';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';
import { RowsPerPage } from "../../../../layout/Table/RowsPerPage";
import { ListToolbar } from '../../../../layout/Workspace';

function UsersTab(props) {
    const [sortDirection, setSortDirection] = useState(null);
    const [sortField, setSortField] = useState(null);
    const [searchText, setSearchText] = useState(null);
    const {users, metaUsers, getUsers, rowsPerPageUsers, setRowsPerPageUsers} = props;

    useEffect(() => {
      return () => {
        store.dispatch(hideNotification());
      }
    }, []);

    useEffect( () => {
      if(getUsers) {
        getUsers( 1, sortField, sortDirection, searchText );
      }

      return () => {
        store.dispatch(hideNotification());
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowsPerPageUsers] );

    /**
     * Apply sort by appliedSortField
     * @param {string} appliedSortField
     */
    function applySort(appliedSortField) {
      let newSortDirection = "";

      if (sortField) {
        if (sortField === appliedSortField) {
          newSortDirection = sortDirection === "asc" ? "desc" : "asc";
        } else {
          newSortDirection = "asc";
        }
      } else {
        newSortDirection = "asc";
      }

      setSortField(appliedSortField);
      setSortDirection(newSortDirection);

      getUsers(metaUsers.current_page, appliedSortField, newSortDirection, searchText, true);
    }

    return (
      <div className="admin-management-tab-content">
        <ListToolbar
          actions={<CreateUser actionCallback={getUsers}/>}
          className="admin-management-toolbar"
          search={ACL.ADMIN.USERS.LIST.hasAccess() && ACL.ADMIN.USERS.SEARCH.hasAccess() ? <Search
                search={(searchText) => {
                  setSearchText(searchText);
                  getUsers(1, null, null, searchText, true);
                }}
                id="users"
              /> : null}
        />
        <div className="admin-management-table">
            <TableComponent
              applySort={(sortField) => applySort(sortField)}
              users={users}
              actionCallback={(useState) => {
                if (useState) {
                  getUsers(
                    metaUsers.current_page,
                    sortField,
                    sortDirection,
                    searchText
                  );
                } else {
                  getUsers();
                }
              }}
            />
        </div>
        <div className="admin-management-pagination">
            <Paginator
              meta={metaUsers}
              settings={(
                <RowsPerPage
                  changeRowsPerPage={(rowsPerPage) => {
                    setRowsPerPageUsers(rowsPerPage);
                  }}
                  id="users"
                />
              )}
              changePage={(page) =>
                getUsers(page, sortField, sortDirection, searchText, true)
              }
            />
        </div>
      </div>
    );
}

export { UsersTab };
